import React, {useState, useEffect} from 'react';

import { Modal, Card, Table, message, Form, Spin } from "antd";
import { Row, Col, Space, Drawer } from "antd";
import { Input, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from 'antd/es/form/Form';

import { ModalUnitManage } from './modal-unit.js';

import { unitColumn } from "./model.js";
import UnitService from '../../../../service/ERP/Unit.service.js'; 
import OptionService from '../../../../service/ERP/Options.service.js';

export default function ModalUnit({show, close, values, selected}) {
    const [form] = useForm(); 
    
    const [unitData, setUnitData] = useState([]);
    const [unitDataWrap, setUnitDataWrap] = useState([]);

    const [openModal,  setOpenModel] = useState(show);
    const [loading,  setLoading] = useState(true);

    const [openManage,  setOpenManage] = useState(false);  
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const optionService = OptionService();
    const unitService = UnitService();
    /** handle logic component */
    const handleClose = () =>{ 
        setTimeout( () => { close(false);  }, 140);
        
    }

    const handleSearch = (value) => {
        if(!!value){    
            const f = unitData.filter( d => (                 
                (d.value?.toLowerCase().includes(value?.toLowerCase())
        ) ) );
             
            setUnitDataWrap(f);            
        } else { 
            setUnitDataWrap(unitData);            
        }

    }

    const handleChoose = (value) => {
        const newvalues = {
            ...value,
            unitname: value.value,
        }
        values(newvalues);
        setOpenModel(false);
    }

    const manageSubmit = ( v ) => {
        // setOpenManage(false);
        setLoading(true); 

        const parm = {...v}; 
        const action = unitService.create( parm );        

        action.then( _ =>  {
            search();
            message.success("สร้างยี่ห้อสำเร็จ.");
        }).catch( err => {
            console.warn(err);
            const data = err?.response?.data;
            message.error( data?.message || "error request");
        })
        .finally( () => {
            setTimeout( () => { setLoading(false) }, 300);
        });        

        // setLoading(true);
        setOpenManage(false);
    }

    /** setting initial component */ 
    const column = unitColumn({handleChoose});
    const search = () =>{
        setLoading(true);
        optionService.optionsUnit().then((res) => {
            let { data } = res.data; 
            setUnitData(data);
            setUnitDataWrap(data);
            // console.log(modalData, data) 
        })
        .catch((err) => { 
            console.warn(err);
            const data = err?.response?.data;
            message.error( data?.message || "error request");  
            // setLoading(false);
        })
        .finally( () => setTimeout( () => { setLoading(false) }, 400));
    }

    useEffect( () => {
        if( !!openModal ){
            search();   
        } 
    }, [openModal]);

    const handleResize = () => {
      setIsSmallScreen(window.matchMedia('(max-width: 767px)').matches);
    };

    useEffect(() => {
      handleResize(); // Set initial screen size

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []); // Empty dependency array ensures the effect runs once on mount
 
    return (
        <>
        <Modal
            open={openModal}
            title="Select Unit"
            afterClose={() => handleClose() }
            onCancel={() => setOpenModel(false) } 
            maskClosable={false}
            style={{ top: 20 }}
            width={800}
            className='modal-unit'
        >
            <Spin spinning={loading} >
                <Space direction="vertical" size="middle" style={{ display: 'flex', position: 'relative'}}  >
                    <Card style={{backgroundColor:'#f0f0f0'}}>
                        <Form form={form} layout="vertical" autoComplete="off" >
                            <Row gutter={[{xs:32, sm:32, md:32, lg:12, xl:12}, 8]} className='m-0'>
                                <Col span={24}>
                                    <Form.Item label="ค้นหา"  >
                                        <Input suffix={<SearchOutlined />} onChange={ (e) => { handleSearch(e.target.value) } } placeholder='ค้นหาชื่อยี่ห้อ'/>
                                    </Form.Item>                        
                                </Col> 
                            </Row> 
                            <Row gutter={[{xs:32, sm:32, md:32, lg:12, xl:12}, 8]} className='m-0'>
                                <Col span={24}>
                                    <Typography.Link onClick={()=>{ setOpenManage(true); }} className='ps-1'>
                                        <span className='hover:underline underline-offset-1'>Create Unit</span>
                                    </Typography.Link> 
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                    <Card style={{minHeight:'60vh' }}>
                        <Table  
                            bordered
                            dataSource={unitDataWrap}
                            columns={column}
                            rowKey="unit_code"
                            pagination={{ 
                                total:unitDataWrap.length, 
                                showTotal:(_, range) => `${range[0]}-${range[1]} of ${unitData.length} items`,
                                defaultPageSize:25,
                                pageSizeOptions:[25,35,50,100]
                            }}
                            scroll={{ x: 'max-content', y:400 }} 
                            size='small'
                        /> 
                    </Card>
                    { openManage &&
                    <Drawer
                        destroyOnClose={true}
                        title="Create Unit"
                        width={isSmallScreen ? '100%' : '50vw'}
                        className='custom-drawer-class'
                        onClose={()=>{setOpenManage(false)}}
                        open={openManage} 
                        styles={{ body: { padding: '0px 24px 8px' } }}
                        getContainer={() => document.querySelector(".modal-unit")}
                    >
                        <ModalUnitManage submit={(val)=>manageSubmit(val)} /> 
                    </Drawer>}
                </Space> 
            </Spin>

        </Modal>    
        </>
    )
}
